import { createContext, useContext } from "react";
import { getUserMarket, getUserMaxRole } from "../utils/rolesUtils";

const UserContext = createContext(null);
export const UserProvider = ({ children }) => {
    return (
        <UserContext.Provider value={{
            userMaxRole: getUserMaxRole(),
            userMarket: getUserMarket()
        }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return context;
};